import { Home } from "../views/home/Home";
import { Routes_Interface } from "./routesInterface";
import { LogExplorer } from "../views/audit/LogExplorer";
import { AuthProvider } from "../views/auth.provider/AuthProviders";
import { UserAttibutes } from "../views/users.attributes/UserAttibutes";
import { AssetRegistry } from "../views/assets/AssetRegistry";
import { ExplorerResults } from "../views/audit/ExplorerResults";
import { EditUserAttribute } from "../views/idam/attributes/EditUserAttribute";
import { CreateUserAttibute } from "../views/idam/CreateUserAttibute";
import { AssetConfiguration } from "../views/assets/AssetConfiguration";
import { ManagedAccounts } from "../views/accounts.managed/ManagedAccounts";
import { PeopleProfileManager } from "../views/people.profile/PeopleProfileManager";

export const standardRoutes: Array<Routes_Interface> = [
    {
        name: 'PEOPLE_PROFILE',
        title: 'People Profile',
        path: "/iam/identity/people-profile",
        element: <PeopleProfileManager />,
        caseSensitive: true,
        activeMenu: 'IDAM.PEOPLE_PROFILE'
    },







    {
        name: 'HOME_',
        path: "/home",
        element: <Home />,
        caseSensitive: true,
        activeMenu: 'HOME'
    },
    {
        name: 'ASSET.REGISTRY_',
        path: "/module/asset-management/registry",
        element: <AssetRegistry />,
        caseSensitive: true,
        activeMenu: 'ASMX'
    },
    {
        name: 'ASSET.CONFIG_',
        path: "/module/asset-management/configuration",
        element: <AssetConfiguration />,
        caseSensitive: true,
        activeMenu: 'ASMX'
    },
    {
        name: 'L0GXP.SEARCH_',
        path: "/log-xplorer",
        element: <LogExplorer />,
        caseSensitive: true,
        activeMenu: 'L0GXP'
    },
    {
        name: 'L0GXP.RESULTS_',
        path: "/log-xplorer/search",
        element: <ExplorerResults />,
        caseSensitive: true,
        activeMenu: 'L0GXP'
    },
    {
        name: 'IDAM.CONFIG_',
        path: "/identity/auth-providers",
        element: <AuthProvider />,
        caseSensitive: true,
        activeMenu: 'PR0VIDERS'
    },
    {
        name: 'USER.MNGD_',
        path: "/identity/users/managed-accounts",
        element: <ManagedAccounts />,
        caseSensitive: true,
        activeMenu: 'USER_MANAGED'
    },
    {
        name: 'USER.ATTR_',
        path: "/identity/user-attributes/configuration",
        element: <UserAttibutes />,
        caseSensitive: true,
        activeMenu: 'USER_ATTR'
    },
    {
        name: 'USER.CREATE_ATTR_',
        path: "/identity/user-attributes/configuration/create",
        element: <CreateUserAttibute />,
        caseSensitive: true,
        activeMenu: 'USER_ATTR'
    },
    {
        name: 'USER.EDIT_ATTR_',
        path: "/identity/user-attributes/configuration/:attribute",
        element: <EditUserAttribute />,
        caseSensitive: true,
        activeMenu: 'USER_ATTR'
    },
]